import { injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';

import Button from '@atlaskit/button/custom-theme-button';
import CheckCircleIcon from '@atlaskit/icon/core/check-circle';
import StatusWorkflowDangerIcon from '@atlaskit/icon-lab/core/status-workflow-danger';
import StatusWorkflowInProgressIcon from '@atlaskit/icon-lab/core/status-workflow-in-progress';
import { token } from '@atlaskit/tokens';
import { CSSToken } from '@atlaskit/tokens/token-names';
import Tooltip from '@atlaskit/tooltip';

import messages from '../../i18n';
import { BuildStatusesMap } from '../../types';

export type TriggerProps = {
  buildCounts: BuildStatusesMap;
  intl: IntlShape;
  onTrigger: () => void;
  isLoading?: boolean;
  showIcon?: boolean;
  ignoreStoppedBuildStatus?: boolean;
};

const Trigger = (props: TriggerProps) => {
  const {
    buildCounts,
    onTrigger,
    isLoading,
    intl,
    showIcon = true,
    ignoreStoppedBuildStatus = false,
  } = props;

  const { FAILED, INPROGRESS, STOPPED, SUCCESSFUL } = buildCounts;
  const total = FAILED + INPROGRESS + STOPPED + SUCCESSFUL;

  let IconComponent = CheckCircleIcon;
  let tooltipLabel = intl.formatMessage(messages.tooltipPassedStatus, {
    count: SUCCESSFUL,
    total,
  });
  let primaryColor: CSSToken = token('color.icon.success');

  if (FAILED) {
    tooltipLabel = intl.formatMessage(messages.tooltipFailedStatus, {
      count: FAILED,
      total,
    });
    IconComponent = StatusWorkflowDangerIcon;
    primaryColor = token('color.icon.danger');
  } else if (STOPPED && !ignoreStoppedBuildStatus) {
    tooltipLabel = intl.formatMessage(messages.tooltipPassedStatus, {
      count: SUCCESSFUL,
      total,
    });
    IconComponent = StatusWorkflowDangerIcon;
    primaryColor = token('color.icon.danger');
  } else if (INPROGRESS) {
    IconComponent = StatusWorkflowInProgressIcon;
    primaryColor = token('color.icon.information');
  }

  const BuildIcon = showIcon ? (
    <IconComponent size="medium" label={tooltipLabel} color={primaryColor} />
  ) : undefined;

  const buttonLabel = !showIcon
    ? intl.formatMessage(messages.buttonLabel, {
        count: total,
      })
    : undefined;

  return (
    <Tooltip content={tooltipLabel} position="bottom">
      <Button
        onClick={onTrigger}
        isLoading={isLoading}
        appearance="link"
        spacing={showIcon ? 'default' : 'none'}
        iconBefore={BuildIcon}
        aria-label={intl.formatMessage(messages.buildInformationButtonLabel)}
      >
        {buttonLabel}
      </Button>
    </Tooltip>
  );
};

// eslint-disable-next-line import/no-default-export
export default injectIntl(Trigger);
